import { InobhutnahmeEntry } from '../model/inobhutnahme';
import { DataFetcher } from './fetcher/DataFetcher';
import { createEqualCommand, RepositoryNocoDbBase } from './repositoryNocoDbBase.ts';

export interface InobhutnahmeSearchParams extends AbstractSearchParams {
  countries?: string;
  duration?: string;
  radiation_source?: string;
  radiation_sleep?: string;
  symptom_disease?: string;
  distance_mast?: string;
  title?: string;
  tags?: string;
  report_from?: string;
  date?: string;
  license?: string;
  country?: string;
}

export class InobhutnahmeRepository extends RepositoryNocoDbBase<InobhutnahmeEntry, InobhutnahmeSearchParams> {
  protected readonly TABLE_NAME = 'inobhutnahme';

  protected readonly API_ROUTE = `${process.env.API_URL}v2/noco/tables/${this.TABLE_NAME}/records`;

  protected readonly META_ROUTE = `${process.env.API_URL}v2/meta/tables/${this.TABLE_NAME}`;

  protected readonly RELEVANCE_FIELD = 'rating';

  protected readonly DATE_FIELD: 'CreatedAt';

  protected readonly STATIC_FILTER = createEqualCommand('publish', 'true');

  protected readonly SELECT_FILTERS = ['country', 'type', 'number_children_taken', 'visitation_rights', 'year'];

  protected readonly SEARCH_FIELDS: (keyof InobhutnahmeEntry)[] = [
    'text',
    'Name',
    'who_filed_complaint',
    'executing_authority',
    'reason'
  ];

  public constructor(_fetcher: DataFetcher) {
    super(_fetcher);
  }
}
